/**
 * Shared debug theme tokens and utilities used across debug tooling components.
 */

export const debugTheme = {
  dark: {
    bg: 'bg-nightshade-900',
    bgAlt: 'bg-nightshade-800',
    border: 'border-nightshade-700',
    text: 'text-nightshade-300',
    textMuted: 'text-nightshade-500',
    textAccent: 'text-tangerine-400',
    textAccent2: 'text-ube-400',
    badge: 'bg-nightshade-700 text-nightshade-400',
    pill: 'bg-nightshade-700 text-nightshade-300 rounded-full px-2 py-0.5 text-[10px] font-medium',
    boolTrue: 'text-matcha-400',
    boolFalse: 'text-nightshade-500',
    chevron: 'text-nightshade-500',
    textBright: 'text-white',
    statusHit: 'text-matcha-400',
    statusMiss: 'text-pomegranate-400',
    // Badge overlay colors
    cardBadge: 'bg-tangerine-500/90 text-white',
    cardBadgeHover: 'hover:bg-tangerine-600/90',
    bundleBadge: 'bg-ube-600/90 text-white',
    bundleBadgeHover: 'hover:bg-ube-700/90',
    detailBadge: 'bg-matcha-600/90 text-white',
    detailBadgeHover: 'hover:bg-matcha-700/90',
    rowBadge: 'bg-tangerine-500/90 text-white',
    rowBadgeHover: 'hover:bg-tangerine-600/90',
    wiringButton: 'bg-nightshade-700/80 text-tangerine-400 hover:bg-nightshade-600',
  },
  light: {
    bg: 'bg-white',
    bgAlt: 'bg-nightshade-50',
    border: 'border-nightshade-200',
    text: 'text-nightshade-900',
    textMuted: 'text-nightshade-600',
    textAccent: 'text-tangerine-600',
    textAccent2: 'text-ube-600',
    badge: 'bg-nightshade-200 text-nightshade-600',
    pill: 'bg-nightshade-200 text-nightshade-600 rounded-full px-2 py-0.5 text-[10px] font-medium',
    boolTrue: 'text-matcha-600',
    boolFalse: 'text-nightshade-400',
    chevron: 'text-nightshade-400',
    textBright: 'text-nightshade-900',
    statusHit: 'text-matcha-600',
    statusMiss: 'text-pomegranate-600',
    // Badge overlay colors
    cardBadge: 'bg-tangerine-400/90 text-white',
    cardBadgeHover: 'hover:bg-tangerine-500/90',
    bundleBadge: 'bg-ube-500/90 text-white',
    bundleBadgeHover: 'hover:bg-ube-600/90',
    detailBadge: 'bg-matcha-500/90 text-white',
    detailBadgeHover: 'hover:bg-matcha-600/90',
    rowBadge: 'bg-tangerine-400/90 text-white',
    rowBadgeHover: 'hover:bg-tangerine-500/90',
    wiringButton: 'bg-nightshade-300 text-tangerine-600 hover:bg-nightshade-400',
  },
} as const;


/** Truncate a long ID string with ellipsis. */
export function truncateId(id: string, max = 12): string {
  return id.length > max ? id.slice(0, max) + '...' : id;
}
